const ON_CHANGE_DEBOUNCE_TIMER = 300;

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.addToCartPanel = document.querySelector('[data-panel="add-to-cart"]');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe('cart-update', (event) => {
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  updateQuantity(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity,
    });

    fetch(`${routes.cart_change_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/json` },
      body: body,
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const cartPanel = document.querySelector('cart-panel');
        cartPanel.refreshCartPanel();
        publish('cart-update', { source: 'cart-items', cartData: parsedState });
        const cartItemCounts = document.querySelectorAll('[data-cart-item-count]');
        cartItemCounts.forEach((cartItemCount) => {
          cartItemCount.textContent = parsedState.item_count;
        });
      })
      .catch(() => {})
      .finally(() => {});
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=dynamic-cart-content`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceSelector = '#cart-item-count';
          const targetSelector = '[data-cart-item-count]';
          const targetElement = document.querySelector(targetSelector);
          const sourceElement = html.querySelector(sourceSelector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
}

customElements.define('cart-items', CartItems);

class CartDrawerItems extends CartItems {}

customElements.define('cart-drawer-items', CartDrawerItems);
